<script>
import axios from 'axios' // axios pour requêtes HTTP
import store from "../../../store";
import apiRoutes from '../../../router/api-routes';
import http from '../../../plugins/https'


export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      programName: '', // Nom du programme

    }
  },
  emit: ['closeCreate', 'refresh'],


  methods: {

    async saveProgram() {
      if (!this.programName?.trim()) {
        console.log('Veuillez entrer un nom de programme.')
        return
      }

      try {
        // Assure-toi que 'store' est bien importé/accessible
        const token = store?.getters?.token || localStorage.getItem('auth_token') || ''

        // Vérification rapide du token
        if (!token) {
          console.log('Token d’authentification manquant. Veuillez vous connecter.')
          return
        }

        // Appel API
        const response = await axios.post(
          apiRoutes.baseURL + apiRoutes.createSfd,
          {
            name: this.programName.trim()
          },
          {
            headers: {
              'Content-Type': 'application/json',
              // Utilisation cohérente du header Authorization
              'Authorization': `Bearer ${token}`,
              // ou API key, si nécessaire (décommenter et ajuster si utile)
              'x-api-key': process.env.VUE_APP_OLD_X_API_KEY,
            }
          }
        );

        console.log('✅ Programme ajouté avec succès :', response.data)

        // Remise à zéro et fermeture
        this.programName = ''
        // await this.getData() 

        this.$emit('close')
        this.$emit('refresh')

        window.location.reload()

      } catch (error) {
        console.error('❌ Erreur lors de l’ajout du programme :', error)

        // Affichage utilisateur plus clair
        const message = error?.response?.data?.message || error?.message || 'Erreur lors de l’ajout du programme.'
        console.log(message)
      }
    }
  }
}
</script>

<template>
  <div class="popup-overlay">
    <div class="popup-content bg-white w-1/3 py-5 2xl:py-10 relative">
      <div class="flex font-c7 text-c22 colorBorderB pb-5 px-5">
        Ajoutez le Nouveau programme
      </div>

      <div class="mt-5">
        <div class="font-c4 text-base mx-5">
          <div class="mb-5 text-left text-82">
            Nom du programme
          </div>
          <div class="input-bloc relative">
            <input v-model="programName" type="text" class="h-14 bgInpout w-full rounded-10 pl-5"
              placeholder="Entrez le nom du programme">
          </div>
        </div>

        <div class="flex justify-end items-center mt-5 mx-5">
          <div class="font-c5 text-red-500 mt-2 text-sm ml-5 cursor-pointer annulerr px-7 py-3 rounded-8"
            @click="$emit('close')">
            Annuler
          </div>
          <div
            class="text-red-500 mt-2 text-sm ml-5 cursor-pointer save px-10 py-3 rounded-8 text-white bg-blue-600 hover:bg-blue-700"
            @click="saveProgram">
            Enregistrer
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.annulerr {
  background-color: #EFF4FB;
}

.save {
  background-color: #241A72;
}

.colorBorderB {
  border-bottom: 3px solid #E7EEF8;
}

.bgInpout {
  /* background-color: #F0F2F7; */
  border: 1px solid #F0F2F7
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 20rem;
}

.relative {
  position: relative;
}
</style>
